/** Специальные виджеты  (Визуальные компоненты) для отображения элементов (полей в карточке) АДМС каталога 
 * Параметрами является:
 * 1. uri - отображаемое свойства (predicate);
 * 2. lang - текущий язык
 * 3. values
*/
import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Icon } from 'antd';
import { BaseViewLiteralComponent } from '../widgets/ViewLiteral';
import { SimpleViewLinkComponent } from '../widgets/ViewLink';

//
//Визуальные компоненты для отображения полей в карточке adms каталога
//

/** Отображение значения по умолчанию. Получается список всех доступных значения, фильтруется по языку. */
export const DefaultValue = ({uri, lang, values}) => {
  //console.log("DefaultValue", uri, lang, values);
  return (
    <BaseViewLiteralComponent uri={uri} lang={lang} values={values}/>
  )
}

//Значения классификационных схем
export const Concepts = ({uri, lang, values, factory, action}) => {
  const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, uri):[];
  const concepts = factory.provider.subsetByLangOrEmpty(subset, lang);
  const isDetail = action!=undefined;
  return (
    <span>
      {concepts.map((item, i) => 
        <span key={i}>
          {isDetail?
            <Button shape="circle" icon="info" size="small" onClick={(e)=>action(e, "detail", item)}><SimpleViewLinkComponent IRI={item.object.value} factory={factory}  triplet={item} lang={lang}/></Button>
          :
            <SimpleViewLinkComponent IRI={item.object.value} factory={factory}  triplet={item} lang={lang}/>
          }
        <br/>
        </span>
      )}
    </span>
  )
}

//Значения классификационных схем
export const Concept = ({uri, lang, values, factory}) => {
  const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, uri):[];
  const concepts = factory.provider.subsetByLangOrEmpty(subset, lang);
  return (
    <span>
      {concepts.map((item, i) => 
        <span key={i}>
          <SimpleViewLinkComponent IRI={item.object.value} factory={factory}  triplet={item} lang={lang}/>
        <br/>
        </span>
      )}
    </span>
  )
}

//Информация об агентах (издатель, публикатор и т.п. foaf:Agent)
export const Foaf = ({uri, lang, values, factory, action}) => {
  const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, uri):[];
  const agens = factory.provider.subsetByLangOrEmpty(subset, lang);
  const isDetail = action!=undefined;
  return (
    <span>
      {agens.map((agent, i) => 
        <div key={i} className="csi_icon_div csi_publisher_div" resource={agent.object.value}>
            <SimpleViewLinkComponent IRI={agent.object.value} factory={factory}  triplet={agent} lang={lang}/>
            {isDetail?
                <Button shape="circle" size="small" onClick={(e)=>action(e, "detail", agent)}><Icon type="info" style={{ verticalAlign: "+0.125em"}}></Icon></Button>
              :
                <span>{agent.object.value}</span>
            }   
        </div>
      )}
    </span>        
  )
}
const ComponentVCard = ({vcard}) => <span>{vcard.object.value}</span>;
const ComponentVCardLink = ({vcard, action=f=>f}) => <Button shape="circle" size="small" onClick={(e)=>action(e, "detail", vcard)} ><Icon type="info" style={{ verticalAlign: "+0.125em"}}></Icon></Button>
//Информация об контактных данных (vCard)
export const vCard = ({uri, lang, values, factory, action}) => {
  const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, uri):[];
  const vcards = factory.provider.subsetByLangOrEmpty(subset, lang);
  const Component = (action)?ComponentVCardLink:ComponentVCard;
  return (
    <span>
      {vcards.map((vcard, i) => 
        <div key={i} className="csi_icon_div csi_copy_div" resource={vcard.object.value}>
          <SimpleViewLinkComponent IRI={vcard.object.value} factory={factory}  triplet={vcard} lang={lang}/>
          <Component vcard={vcard} action={action}/>
        </div>
      )}
    </span>        
  )
}

//Информация о поддерживаемых языках
export const Language = ({uri, lang, values, factory}) => {
  const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, uri):[];
  const langs = factory.provider.subsetByLangOrEmpty(subset, lang);
  return (
    <span>
      {langs.map((item, i) => 
        <div key={i} className="csi_icon_div csi_language_div" resource={item.object.value}>
            <SimpleViewLinkComponent IRI={item.object.value} factory={factory}  triplet={item} lang={lang}/>
        </div>
      )}
    </span>        
  )
}

//Внешние (активные линки)
export const ExternalLink = ({uri, lang, values, factory, history}) => {
  const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, uri):[];
  const links = factory.provider.subsetByLangOrEmpty(subset, lang);
  return (
    <span>
      {links.map((item, i) => 
        <p key={i}>
          {item.object.value.startsWith("/viewemd/")?
              <Link to={item.object.value}>{item.object.value}</Link>
            :
            <a href={item.object.value} target="_blank">{item.object.value}</a>
          }          
        </p>
      )}
    </span>        
  )
}

//Скачивание файлов
export const FileDownload  = ({uri, lang, values, factory}) => {
  const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, uri):[];
  const links = factory.provider.subsetByLangOrEmpty(subset, lang);
    return (
    <span>
      {links.map((link, i) => 
          <a key={i} href={link.object.value} target="_blank">{link.object.value}</a>
      )}
    </span>        
  )
}

export const AssetLink = ({uri, lang, values, factory}) => {
  const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, uri):[];
  const links = factory.provider.subsetByLangOrEmpty(subset, lang);
  return (
    <span>
      {links.map((asset, i) => 
        <p key={i}>
          <Link to={"/adms/"+encodeURIComponent(asset.object.value)} target="_blank" resource={asset.object.value}>
            <SimpleViewLinkComponent IRI={asset.object.value} factory={factory}  triplet={asset} lang={lang}/>
          </Link>
        </p>
      )}
    </span>        
  )
}

export const AssetLink2 = ({field, value}) => {
    return (
<div className="csi_value_div">
    {value.map((asset, i) => <Link to={"/emd/"+asset.NodId} key={i}>{asset.NName}<br/></Link>)}
</div>        
    )
}